export const PROFILE_UPDATE_SUCCESS = "PROFILE_UPDATE_SUCCESS";
export const SET_SELECTED_SCHOOL = "SET_SELECTED_SCHOOL";
